import { FadeUp } from "./Reveal";

const Accent = ({ children }) => <span className="text-gaia-terracotta">{children}</span>;
const Soft = ({ children }) => <em className="italic">{children}</em>;

// Keywords reconstruct the exact "Searching for …" lines (content unchanged).
const SEARCHING = ["balance", "purpose", "connection", "peace"];

const Philosophy = () => {
  return (
    <section id="philosophy" className="bg-gaia-bg py-20 md:py-28" data-testid="philosophy-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        {/* Header: statement + supporting line */}
        <div className="grid grid-cols-1 items-end gap-8 md:grid-cols-12 md:gap-12">
          <div className="md:col-span-8">
            <FadeUp>
              <h2 className="font-serif text-4xl font-light leading-[1.1] tracking-tight text-gaia-charcoal md:text-6xl" data-testid="philosophy-statement">
                We spend so much of our lives <Soft>searching.</Soft>
              </h2>
            </FadeUp>
          </div>
          <div className="md:col-span-4">
            <FadeUp delay={0.1}>
              <p className="max-w-sm font-sans text-base font-light leading-relaxed text-gaia-charcoal/65 md:text-lg">
                Sometimes forgetting that what we're looking for has never been somewhere else. It has always been <Accent>within us.</Accent>
              </p>
            </FadeUp>
          </div>
        </div>

        {/* The search — a calm bento row of cards */}
        <div className="mt-12 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4 md:gap-4">
          {SEARCHING.map((word, i) => (
            <FadeUp key={word} delay={0.1 + i * 0.08}>
              <div
                className="group flex h-full flex-col justify-between rounded-2xl border border-gaia-charcoal/12 p-6 transition-all duration-500 hover:-translate-y-1 hover:border-gaia-terracotta/40 hover:bg-white/50 hover:shadow-[0_22px_45px_-26px_rgba(46,43,41,0.4)] md:p-7"
                data-testid={`searching-card-${word}`}
              >
                <span className="font-sans text-[11px] tabular-nums tracking-[0.24em] text-gaia-taupe transition-colors duration-500 group-hover:text-gaia-terracotta">
                  0{i + 1}
                </span>
                <p className="mt-10 font-serif text-xl font-light leading-snug text-gaia-charcoal/50 md:text-2xl">
                  Searching for <span className="text-gaia-charcoal">{word}</span>
                </p>
                <span className="mt-5 block h-px w-8 bg-gaia-charcoal/20 transition-all duration-500 group-hover:w-14 group-hover:bg-gaia-terracotta" />
              </div>
            </FadeUp>
          ))}
        </div>

        {/* The resolution — a dark invitation card that answers the search */}
        <FadeUp delay={0.1}>
          <div
            className="gaia-grain relative mt-4 overflow-hidden rounded-[28px] bg-gaia-charcoal px-8 py-14 md:mt-6 md:px-16 md:py-20"
            style={{ boxShadow: "0 40px 80px -40px rgba(46,43,41,0.5)" }}
            data-testid="philosophy-invitation"
          >
            <div className="relative z-10 max-w-4xl">
              <p className="font-serif text-3xl font-light leading-[1.2] text-gaia-bg md:text-5xl md:leading-[1.16]">
                Gaia Space is an invitation to slow down, soften, and remember who you are—a gentle journey <Accent>back home to yourself.</Accent>
              </p>
            </div>
            {/* quiet zen marker */}
            <div className="pointer-events-none absolute bottom-8 right-8 hidden h-10 w-10 items-center justify-center rounded-full border border-gaia-bg/20 md:flex">
              <span className="h-1.5 w-1.5 rounded-full bg-gaia-terracotta" />
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
};

export default Philosophy;
